export default {
      id: "Tourist-services-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Tourist-services",
      toString: function () {
        return this.url;
      }
    }